import React from 'react'
import {Button, Input, Modal, Label, ModalHeader, ModalBody, ModalFooter, FormGroup} from 'reactstrap'
import {updateInfoBox, validateFBAFullyBoxed} from "../../../services/api/apiNextBox";

class ModalEditInfoBox extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isFinishUpdateFbaInfo: false,
            realWeight: '',
            realHeight: '',
            realWidth: '',
            realLength: '',
            isLoadingSave: false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen !== prevProps.isOpen && this.props.isOpen) {
            const {realWeight, realHeight, realWidth, realLength} = this.props

            this.setState({
                realWeight: realWeight,
                realHeight: realHeight,
                realWidth: realWidth,
                realLength: realLength
            })
        }
    }

    _renderIconLoading = () => {
        if (this.state.isLoadingSave)
            return <i className='icon-spinner2 spinner ml-2'/>
    }

    _handleClickSave = async () => {
        this.setState({isLoadingSave: true})
        
        try {
            const {boxId} = this.props
            const {realWeight, realHeight, realWidth, realLength, isFinishUpdateFbaInfo} = this.state
            const data = {
                "confirm_update_fba_info": isFinishUpdateFbaInfo,
                "weight": realWeight,
                "dimension": {
                    "width": realWidth,
                    "height": realHeight,
                    "length": realLength
                }
            }

            const box = this.props.boxes.find(box => box.id === boxId)
            if(box.is_fba_box === true && isFinishUpdateFbaInfo === true) {
                const res = await validateFBAFullyBoxed(this.props.boxId)
                if(res.data.data === false) {
                    if(!window.confirm('Thùng này chưa được đóng hết, bạn có muốn tiếp tục không?')) {
                        this.setState({isLoadingSave: false})
                        this.props.onToggleModal()
                        return
                    }
                }
            }

            const {data: {success, message, data: {is_order_fully_boxed, boxes_can_create_batch_ship} = {}}} = await updateInfoBox({boxId, data})

            if (!success) {
                this.setState({isLoadingSave: false, isFinishUpdateFbaInfo: false})
                throw new Error(message)
            }

            this.setState({
                isLoadingSave: false,
                isFinishUpdateFbaInfo: false
            }, async () => {
                this.props.onToggleModal()
                if (is_order_fully_boxed && Array.isArray(boxes_can_create_batch_ship) && boxes_can_create_batch_ship.length > 0) {
                    this.props.onOrderFullyBoxed(boxes_can_create_batch_ship)
                } else {
                    await this.props.onReloadBox()
                }
            })

        } catch (e) {
            this.setState({
                isLoadingSave: false,
                isFinishUpdateFbaInfo: false
            })
            alert(e.message)
        }

        this.setState({
            isLoadingSave: false
        })
    }

    _handleCloseModal = () => {
        this.props.onToggleModal()
    }

    _handleCheckFinishUpdateFBAInfo = (e) => {
        this.setState({
            isFinishUpdateFbaInfo: e.target.checked
        })
    }

    _handleChangeInput = (e) => {
        const {name, value} = e.target
        this.setState({
            [name]: value
        })
    }

    _isDisableButton = () => {
        const {realWeight, realHeight, realWidth, realLength} = this.state
        if (!!realWeight && !!realHeight && !!realWidth && !!realLength){
            return false
        }

        return true
    }

    render() {
        const {isOpen, className, boxId} = this.props
        const {realWeight, realHeight, realWidth, realLength, loadingUpdate} = this.state
        const isDisable = this._isDisableButton()

        return (
            <div>
                <Modal isOpen={isOpen} toggle={this._handleCloseModal} className={className}>
                    <ModalHeader toggle={this._handleCloseModal}>Thùng #{boxId}</ModalHeader>
                    <ModalBody>
                        <h3 className="font-weight-bold">Cân nặng thực tế</h3>
                        <FormGroup>
                            <Input name='realWeight' value={realWeight} onChange={this._handleChangeInput} placeholder="Nhập cân nặng thực của thùng"/>
                            <label className='unit'>kg</label>
                        </FormGroup>
                        <h3 className="font-weight-bold">Kích thước thực tế</h3>
                        <FormGroup>
                            <Input name='realLength' value={realLength} onChange={this._handleChangeInput} placeholder="Chiều dài"/>
                            <label className='unit'>cm</label>
                        </FormGroup>

                        <FormGroup>
                            <Input name='realWidth' value={realWidth} onChange={this._handleChangeInput} placeholder="Chiều rộng"/>
                            <label className='unit'>cm</label>
                        </FormGroup>

                        <FormGroup>
                            <Input name='realHeight' value={realHeight} onChange={this._handleChangeInput} placeholder="Chiều cao"/>
                            <label className='unit'>cm</label>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <div className="checkFinish">
                            <Label check className="mr-2">
                                <Input type="checkbox" onChange={this._handleCheckFinishUpdateFBAInfo} />
                                <span>Kết thúc cập nhật thông tin.</span>
                            </Label>
                        </div>

                        <Button color="secondary" onClick={this._handleCloseModal}>Cancel</Button>{' '}
                        <Button color="primary" onClick={this._handleClickSave} disabled={isDisable}>
                            Save
                            {this._renderIconLoading()}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default ModalEditInfoBox
